// API 呼び出しの共通クライアント（Issue #36）。
//
// **アクセストークンを必ず載せるためにある。** 予測APIは各ページが axios を直接呼んでおり
// Authorization を送っていなかった。#33 の認可が入った今、このままだと契約者もサーバから
// 匿名として扱われ、有料化を有効にした瞬間に全レースがロック表示になる。
//
// 未ログインでも無料枠は 200 が返るので、トークンが無いときはヘッダを付けずに送る。
import axios from 'axios';

export const API_BASE = 'https://chiriri-keiba.com';

export const getAccessToken = () => localStorage.getItem('access_token');

const apiClient = axios.create({ baseURL: API_BASE });

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
